import { render, staticRenderFns } from "./AgeVerification.vue?vue&type=template&id=1c7788ce&scoped=true&"
import script from "./AgeVerification.vue?vue&type=script&lang=js&"
export * from "./AgeVerification.vue?vue&type=script&lang=js&"
import style0 from "./AgeVerification.vue?vue&type=style&index=0&id=1c7788ce&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7788ce",
  null
  
)

export default component.exports